var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C7.77614 15 8 14.7761 8 14.5C8 14.2239 7.77614 14 7.5 14C7.22386 14 7 14.2239 7 14.5C7 14.7761 7.22386 15 7.5 15Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15C15.7761 15 16 14.7761 16 14.5C16 14.2239 15.7761 14 15.5 14C15.2239 14 15 14.2239 15 14.5C15 14.7761 15.2239 15 15.5 15Z",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1H4.72727L6.55455 9.92645C6.61689 10.2334 6.78766 10.5091 7.03696 10.7053C7.28626 10.9015 7.5982 11.0058 7.91818 10.9998H14.5455C14.8654 11.0058 15.1774 10.9015 15.4267 10.7053C15.676 10.5091 15.8467 10.2334 15.9091 9.92645L17 4.33325H5.40909",
    stroke: "#050409",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart12);
export default __webpack_public_path__ + "static/media/shopping-cart-12.a7492cba1b31bc03453baadd0751a534.svg";
export { ForwardRef as ReactComponent };